import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getSizeOfDiamond } from '../../../helpers/getSizeOfDiamond';
import { diamondsConstants } from '../constants';
import cancelExchangeAPI from '../../../api/diamonds/exchanges/cancelExchange';
import claimExchangeAPI from '../../../api/diamonds/exchanges/claimExchange';

const ExchangeCard = (props) => {
  const { deal, handleParseExchanges, setToast } = props;
  const { userData, token } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const getDiamondTopOffset = (type) => {
    if (type === 0) {
      return 0;
    }
    if (type === 1) {
      return 8;
    }
    if (type === 2) {
      return 3;
    }
  };

  const handleCancelExchange = async () => {
    await cancelExchangeAPI(token, navigate, { exchangeId: deal.id });
    handleParseExchanges();
  };
  const handleClaimExchange = async () => {
    const resp = await claimExchangeAPI(token, navigate, { exchangeId: deal.id });
    handleParseExchanges();

    if (resp?.message && resp?.message?.includes('Success')) {
      setToast({
        message: 'Diamonds exchanged with success ',
        type: 'error',
        show: true
      });

      return;
    }
    if (resp.errorCode > 0) {
      setToast({
        message: resp.message,
        type: 'error',
        show: true
      });
      return;
    }
  };

  return (
    <>
      <p className="username">{deal.username}</p>
      <div className="exchangeCard">
        <div
          className="deselectItem"
          onClick={userData.id === deal.userId ? handleCancelExchange : handleClaimExchange}>
          {userData.id === deal.userId ? (
            <div className="close">Cancel</div>
          ) : (
            <div className="confirm">Exchange</div>
          )}
        </div>

        <div className="diamondsToOffer">
          {deal.diamondsToOffer.map((offer) => {
            return (
              <div
                key={offer.id}
                style={{
                  backgroundSize: getSizeOfDiamond(offer.type),
                  backgroundImage: `url(${diamondsConstants[offer.type]?.icon})`
                }}
                className="selectedDiamondImg"
              />
            );
          })}
        </div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="inactiveExchange"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g id="Item/tabler-icon-transform">
            <path
              id="Vector"
              d="M21 11V8C21 7.46957 20.7893 6.96086 20.4142 6.58579C20.0391 6.21071 19.5304 6 19 6H13M13 6L16 9M13 6L16 3M3 13V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18H11M11 18L8 15M11 18L8 21M3 6C3 6.79565 3.31607 7.55871 3.87868 8.12132C4.44129 8.68393 5.20435 9 6 9C6.79565 9 7.55871 8.68393 8.12132 8.12132C8.68393 7.55871 9 6.79565 9 6C9 5.20435 8.68393 4.44129 8.12132 3.87868C7.55871 3.31607 6.79565 3 6 3C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6ZM15 18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
        <div className="diamondsToRequest">
          {deal.diamondsToRequest.map((offer, i) => {
            return (
              <div
                key={offer.id + i}
                style={{
                  marginTop: getDiamondTopOffset(offer.type),
                  backgroundSize: getSizeOfDiamond(offer.type),
                  backgroundImage: `url(${diamondsConstants[offer.type]?.icon})`
                }}
                className="selectedDiamondImg"
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

ExchangeCard.propTypes = {
  deal: PropTypes.object,
  handleParseExchanges: PropTypes.func,
  setToast: PropTypes.func
};
export default ExchangeCard;
